import {create} from 'zustand'

export interface IRegistationStore {
    setSelectiveProcessId(id: string): void;
    setRegistrationId(id: string): void;
    onResetRegistration(): void;
    registrationId?: string;
    selectiveProcessId: string;
}

export const UseRegistration = create<IRegistationStore>((set) => ({
    selectiveProcessId: '',
    setSelectiveProcessId: (id: string) => set((old) => ({...old, selectiveProcessId: id})), 
    setRegistrationId: (id: string) => set((old) => ({...old, registrationId: id})),
    onResetRegistration: () => set((old) => ({...old, isPCD: false, modalityList: [], isPPPIQ: false, registrationId: undefined, selectiveProcessId: ''})) 
}))